import { School } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";

import type { ServiceSection } from "@/types/sections";

const ourProcessSection: ServiceSection = {
  type: SECTION_TYPES.OUR_PROCESS,
  content: {
    header: "Our Process",
    subheader: "We're a team of professionals who are passionate about what we do.",
    steps: [
      {
        title: "Step 1",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur",
      },
      {
        title: "Step 2",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur",
      },
      {
        title: "Step 3",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur",
      },
    ],
  },
  meta: {
    displayName: "Our Process",
    displayDescription: "Tell your customers about your process.",
    displayIcon: School,
    variantsCount: 4,
    variantPinned: 2, // default to the third variant since it's the best design by far.
  },
  aiPrompt: (website, service, serviceList) => {
    const industry = website?.industry;

    if (!service?.name) {
      return `Outline 2-4 distinct steps that detail our unique process for delivering the "${serviceList}" service at a small${industry ? ` ${industry}` : ""} business. 

            Each step should be tailored to our specific industry: "${industry}", and reflect our commitment to quality and customer satisfaction.

            Ensure the steps flow logically from initial contact to service completion, using industry-specific language and realistic timelines. Keep each step under 75 words.

            Example steps (these are generic, be more specific):
            - Initial consultation and estimate: Our team meets with you to understand your needs, assess the scope, and provide a detailed cost estimate tailored to your project.
            - Scheduling and planning: We coordinate a convenient service time and create a comprehensive action plan, including required resources and timeline.
            - Service execution and completion: Our experts efficiently perform the work to the highest standards, followed by a thorough quality check and client walkthrough.

            Create short descriptions for each step that are logical and make sense for the "${serviceList}" service.

            Emphasize what sets our process apart in ${industry ? `the ${industry} industry` : "our industry"}, making it sound professional yet approachable.`;
    }

    return `Outline 2-4 distinct steps that detail our unique process for delivering the "${service.name}" service at a small${industry ? ` ${industry}` : ""} business that offers the following services: ${serviceList}. 

            Each step should be tailored to our specific service: "${service.name}", and reflect our commitment to quality and customer satisfaction.

            Ensure the steps flow logically from initial contact to service completion, using industry-specific language and realistic timelines. Keep each step under 75 words.

            Example steps (these are generic, be more specific):
            - Initial consultation and estimate: Our team meets with you to understand your needs, assess the scope, and provide a detailed cost estimate tailored to your project.
            - Scheduling and planning: We coordinate a convenient service time and create a comprehensive action plan, including required resources and timeline.
            - Service execution and completion: Our experts efficiently perform the work to the highest standards, followed by a thorough quality check and client walkthrough.

            Create short descriptions for each step that are logical and make sense for the "${service.name}" service.

            Emphasize what sets our process apart in ${industry ? `the ${industry} industry` : "our industry"}, making it sound professional yet approachable.`;
  },
};

export default ourProcessSection;
